export class Image {

  original: string = null;

  current: string = null;

  file: any = null;

  constructor(original?: string) {
    this.original = original;
    this.current = original;
  }
}
